import { z } from "zod";

export const RoomSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    room_type_id: z.string().uuid(),
    room_number: z.string(),
    status: z.enum(["available", "occupied", "maintenance"]), // Sesuai dengan kemungkinan status
    condition: z.enum(["clean", "dirty", "needs_maintenance"]), // Bisa disesuaikan dengan kondisi lain
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

export const RoomTypeSchema = z.object({
    name: z.string(),
    total_rooms: z.number().int().positive(),
    occ_adults: z.number().int().nonnegative(),
    occ_children: z.number().int().nonnegative(),
    description: z.string().nullable(),
    // Nullable: property deactivation nulls this server-side (DeactivatePropertyChannexJob).
    channex_id: z.string().uuid().nullable(),
    property_id: z.string().uuid(),
    id: z.string().uuid(),
    updated_at: z.string().datetime(),
    created_at: z.string().datetime(),
    rooms: z.array(RoomSchema),
});

export const CreateRoomTypeResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: RoomTypeSchema,
});

export type Room = z.infer<typeof RoomSchema>;
export type RoomType = z.infer<typeof RoomTypeSchema>;
export type RoomTypeResponse = z.infer<typeof CreateRoomTypeResponseSchema>;
